import {useTranslation} from 'react-i18next'
import {isArrayAndNotEmpty} from '../components/observations/Utils'

const TranslateUtils = () => {
    const {t} = useTranslation()

    const translateLanguage = key => {
        return key !== t(key, {ns: 'language'}) ? t(key, {ns: 'language'}) : key
    }

    const translateTerm = key => {
        return key !== t(key, {ns: 'term'}) ? t(key, {ns: 'term'}) : key
    }

    const translateReport = key => {
        return key !== t(key, {ns: 'report'}) ? t(key, {ns: 'report'}) : key
    }

    const translateDatatable = key => {
        return key !== t(key, {ns: 'datatable'})
            ? t(key, {ns: 'datatable'})
            : key
    }
    const translateKeys = key => {
        return key !== t(key, {ns: 'keys'}) ? t(key, {ns: 'keys'}) : key
    }

    const translateCommons = key => {
        return key !== t(key, {ns: 'common'}) ? t(key, {ns: 'common'}) : key
    }

    const translateObservations = key => {
        return key !== t(key, {ns: 'observation'})
            ? t(key, {ns: 'observation'})
            : key
    }

    const translateOptions = (arr = []) => {
        let options = []

        if (!!isArrayAndNotEmpty) {
            for (let i = 0; i < arr.length; i++) {
                let item = {...arr[i]}
                item.label =
                    arr[i]?.label !== t(arr[i]?.label, {ns: 'options'})
                        ? t(arr[i]?.label, {ns: 'options'})
                        : arr[i]?.label

                options.push(item)
            }
        }
        return options
    }

    const translateAddress = (key, type) => {
        return key !== t(key, {ns: type}) ? t(key, {ns: type}) : key
    }

    const translateAddressOptions = (arr = [], type) => {
        let options = []

        if (!!isArrayAndNotEmpty) {
            for (let i = 0; i < arr.length; i++) {
                let item = {...arr[i]}
                item.label =
                    arr[i]?.label !== t(arr[i]?.label, {ns: type})
                        ? t(arr[i]?.label, {ns: type})
                        : arr[i]?.label

                options.push(item)
            }
        }
        return options
    }

    return {
        translateLanguage,
        translateDatatable,
        translateObservations,
        translateKeys,
        translateCommons,
        translateOptions,
        translateTerm,
        translateReport,

        translateAddress,
        translateAddressOptions,
    }
}

export default TranslateUtils
